/**
 * File: apps/qbench-cp/reactapp/src/shared/components/Modal/index.js
 *
 * Purpose: Provides a reusable modal shell with a title, a loading state, and a close button.
 *
 * Scope: Shared QBModal component.
 *
 * Tags: customer-portal
 *
 * Overview: Wraps react-bootstrap's Modal to render a static-backdrop dialog with a header
 *     title, a body that shows either a centered spinner (while loading) or the passed
 *     children, and a footer with a Close button that is hidden while loading. Visibility and
 *     dismissal are controlled entirely by the show and handleClose props from the caller.
 *
 * Exports: QBModal (default export), a generic modal wrapper.
 */

import { Modal, Spinner } from 'react-bootstrap';
import { Button } from '../Button';

const QBModal = ({ show, handleClose, title, loading, size, children }) => {
  return (
    <Modal show={show} onHide={handleClose} backdrop="static" size={size || ''}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {loading && (
            <Spinner
              animation="border"
              style={{ width: '10rem', height: '10rem' }}
            />
          )}
          {!loading && children}
        </div>
      </Modal.Body>
      <Modal.Footer>
        {!loading && (
          <Button outlined onClick={handleClose}>
            Close
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default QBModal;
